/* eslint-disable react/react-in-jsx-scope */
import { useRef, useState, useEffect } from 'react';
import ProTable from '@ant-design/pro-table';
import { Button, Space, Tabs, Tag } from 'antd';
import { history } from 'umi';
import { queryUserCurrentTrainingPlan } from '@/services/userPlan';
import { render } from 'react-dom';

const ExclusivePlan = (props) => {
  const { userId } = props;
  const actionRef = useRef();
  // 计划数据
  const [planData, setPlanData] = useState([]);

  useEffect(() => {
    getUserPlanData();
  }, []);

  function getUserPlanData() {
    queryUserCurrentTrainingPlan({
      requestData: { userId: userId },
    }).then(({ data, code, msg }) => {
      if (code === '00000') {
        const cache = [];
        cache.push({
          planName: data?.planName,
          planSourceDesc: data?.planSourceDesc,
          planTypeDesc: data?.planTypeDesc,
          planGetTime: data?.planGetTime,
          planGetWayDesc: data?.planGetWayDesc,
          courseCount: data?.courseCount,
          processedCount: data?.processedCount,
        });
        setPlanData(cache);
      }
    });
  }

  const columns = [
    {
      title: '在练计划',
      dataIndex: 'planName',
    },
    {
      title: '计划来源',
      dataIndex: 'planSourceDesc',
      hideInSearch: true,
      render: (text) => {
        return <Tag> {text}</Tag>;
      },
    },
    {
      title: '计划类型',
      dataIndex: 'planTypeDesc',
      hideInSearch: true,
    },
    {
      title: '计划获取时间',
      dataIndex: 'planGetTime',
      hideInSearch: true,
    },
    {
      title: '获得方式',
      dataIndex: 'planGetWayDesc',
      hideInSearch: true,
    },
    {
      title: '总课时/已训练',
      dataIndex: 'processedCount',
      hideInSearch: true,
      render: (_, record) => {
        if (record.courseCount && record.processedCount) {
          return `${record.courseCount || ''}节/${
            record.processedCount || ''
          }节`;
        }
        return `-`;
      },
    },
  ];

  function editAction(record) {
    // window.open(
    //   ('/action/exclusivePlan/cycle?phone=' + record.userPhone),
    //   '_blank',
    // );
    history.push('/action/exclusivePlan/cycle?id=' + record.id);
  }

  return (
    <div>
      {/* <Tabs defaultActiveKey="0" onChange={onTabChange}>
        {tabSource.map((e, index) => {
          const { key } = e;
          return (
            <TabPane tab="概览" key="0">
              <OverView userId={query.id} />
            </TabPane>
          );
        })}
      </Tabs> */}

      <ProTable
        columns={columns}
        actionRef={actionRef}
        dataSource={planData}
        options={false}
        columnsState={{
          persistenceKey: 'pro-table-exclusivePlan',
          persistenceType: 'localStorage',
        }}
        rowKey="id"
        search={false}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
      />
    </div>
  );
};

export default ExclusivePlan;
